module.exports = __webpack_public_path__ + "assets/img/ingbank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/ingbank@2x.png
// module id = 133
// module chunks = 0